import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const WeatherBadge = ({ lat, lon, day, testid = "weather-badge" }) => {
  const [w, setW] = useState(null), [err, setErr] = useState("");
  useEffect(() => {
    if (lat == null || lon == null || !day) return;
    setW(null); setErr("");
    api.get("/venues/weather", { params: { lat, lon, day } }).then((r) => setW(r.data)).catch(() => setErr("Weather unavailable"));
  }, [lat, lon, day]);
  if (lat == null || lon == null) return null;
  if (err) return <p className="text-[11px] text-muted-foreground" data-testid={testid}>{err}</p>;
  if (!w) return <p className="text-[11px] text-muted-foreground" data-testid={testid}>Checking weather…</p>;
  const tone = w.heat_flag === "high" ? "text-traffic-red" : w.heat_flag === "moderate" ? "text-traffic-amber" : "text-muted-foreground";
  return (
    <p className={`text-[11px] ${tone}`} data-testid={testid} title={w.source}>
      {`${w.kind === "forecast" ? "Forecast" : "Typical"} ${w.day}: ${w.temperature_2m_min ?? "–"}–${w.temperature_2m_max ?? "–"}°C, feels ${w.apparent_temperature_max ?? "–"}°C, humidity ${w.relative_humidity_2m_mean ?? "–"}%, rain ${w.precipitation_sum ?? 0} mm, wind ${w.wind_speed_10m_max ?? "–"} km/h`}
      {w.heat_flag === "high" && " · heat: plan extra fluids and shorter high-intensity blocks"}
    </p>
  );
};
